//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridMenu from '../../component/grid/gridMenu';
import autoScrollMixin from '../../component/mixins/autoScrollMixin';

export default {
    name: 'allApp',
    mixins: [autoScrollMixin],
    props: {
        //是否全部展开
        expandAll: Boolean,
        //不需要长按勾选
        noChoose: Boolean,
    },
    created() {
        this.loadMoreApp()
    },
    data() {
        return {
            collapseList: [], //折叠面板数据
            inChoose: false,
        }
    },
    methods: {
        setCollapsed() {
            if (this.expandAll && !this.scrollTop) {
                var indexes = this.expandAll ? this.collapseList.map((n, i) => {
                    n.active = true;
                    return i
                }) : [0];
                this.onChange(indexes);
            } else {
                this.onChange(this.activeIndexes)
            }
        },
        loadMoreApp() {
            const pars = {};
            pars.type = 'all';
            this.$x.post('home/getMoreApps', pars).then(res => {
                const haveApps = res.haveApps;
                //app列数据集成到折叠面板列表内
                const collapseList = res.allParentApps.map((row, i) => {
                    row.active = false;
                    row.apps = res.allApps.filter((row2, jindex) => {
                        if (row2.pid === row.id) {
                            row2.chosen = false;
                            row2.iconmobile = row2.bsimg;
                            row2.parentIndex = i;
                            row2.xcolorid = jindex % 6 + 1;
                            for (var n = 0; n < haveApps.length; n++) {
                                if (row2.id === haveApps[n].id) {
                                    row2.fvid = haveApps[n].fvid;
                                    row2.chosen = true;
                                }
                            }
                            return row2
                        }
                    });
                    return row
                });
                this.collapseList = collapseList;
                this.$nextTick(() => {
                    this.setCollapsed()
                    this.autoScroll()
                })
            })
        },
        onFavChoose(e) {
            if (!this.noChoose) {
                this.inChoose = !this.inChoose;
                return this.inChoose;
            }
        },
        //添加收藏
        addFavApp(cell) {
            //非编辑状态且已收藏则无法执行
            if (!this.inChoose) {
                return false;
            }
            //已收藏则取消收藏,未收藏将收藏
            if (cell.chosen) {
                this.$x.post('home/delApps', { id: cell.fvid })
                    .then(res => {
                        cell.chosen = false;
                    })
            } else {
                this.$x.post('home/addApps', { xpath: cell.xpath })
                    .then(res => {
                        cell.chosen = true;
                    })
            }
        },
        openApp(cell) {
            //非编辑状态下执行
            if (!this.inChoose) {
                this.$x.jumpMenu(cell, {
                    index: JSON.stringify(this.activeIndexes),
                    scrollTop: this.scrollTop || this.getOffsetTop()
                })
            }
        },
    },
    components: { GridMenu }
}
